var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"border":"left","close-text":"Close Alert","color":"red","dark":"","dismissible":"","value":true,"type":"error"},on:{"input":_vm.onClose}},[_vm._v(_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }